import { render, staticRenderFns } from "./PromocodesTable.vue?vue&type=template&id=514474ba&"
import script from "./PromocodesTable.vue?vue&type=script&lang=js&"
export * from "./PromocodesTable.vue?vue&type=script&lang=js&"
import style0 from "./PromocodesTable.vue?vue&type=style&index=0&id=514474ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports